import {
  Button,
  Typography,
  InputAdornment,
  IconButton,
  Tooltip,
} from "@mui/material";
import { toMoney } from "../../util/Utils";
import { Box, TextField } from "@mui/material";
import useBreakpoints from "../../hooks/useBreakpoints";
import Detail from "../../main/detail/Detail";
import { useEffect, useState } from "react";
import { UseDeliveryReport } from "./UseDeliveryReport";
import { rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useLocation, useNavigate } from "react-router-dom";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { DataGrid } from "@mui/x-data-grid";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import CustomPagination from "../../components/CustomPagination";

export default function OrderDeliveryDetails(props) {
  const { isSmall } = useBreakpoints();
  const { GetDeliveryReport, GetDeliveryReportByDate } = UseDeliveryReport();
  const [data, setData] = useState();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const navigate = useNavigate();
  const [statusGrid, setStatusGrid] = useState();
  const [showOrdersGrid, setShowOrdersGrid] = useState();
  const [pageState, setPageState] = useState({
    page: 1,
  });

  useEffect(() => {
    if (location.state.deliverydate) {
      GetDeliveryReportByDate(location.state.deliverydate, (callback) => {
        setData(callback);
      });
    }
  }, [location.state]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "stateTitle",
      width: 170,
      align: "center",
      headerName: "وضعیت",
      headerAlign: "center",
    },
    {
      field: "count",
      width: 120,
      align: "center",
      headerName: "تعداد",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.count ? toMoney(cellValues.row.count) : 0}
          </Typography>
        );
      },
    },
    {
      field: "orders",
      width: 100,
      align: "center",
      headerName: "سفارشات",
      sortable: false,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Button
            variant="contained"
            onClick={() => {
              setPageState((old) => ({ page: 1 }));
              setShowOrdersGrid(cellValues.row.orders);
            }}
          >
            سفارشات
          </Button>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "گزارشات",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/deliveryreport" },
          {
            name: `جزئیات گزارش ارسال سفارشات ${data?.dayname ? data?.dayname : ""}`,
            url: "/deliveryreport/details",
          },
        ],
      }}
    >
      {data ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="تعداد سفارشات"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              value={data?.totalOrder ? toMoney(data?.totalOrder) : "0"}
              variant="filled"
              InputProps={{
                readOnly: true,
                autoComplete: "off",
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title="جزيیات ارسال">
                      <IconButton
                        sx={{ p: 0.3 }}
                        onClick={() => {
                          setShowOrdersGrid();
                          setStatusGrid({
                            rows: data.totalOrderDetail,
                            title: "همه سفارشات",
                          });
                        }}
                      >
                        <ListAltIcon color="secondary" fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="ارسال پیک"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              value={data?.peikOrder ? toMoney(data?.peikOrder) : 0}
              variant="filled"
              InputProps={{
                readOnly: true,
                autoComplete: "off",
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title="جزيیات ارسال">
                      <IconButton
                        sx={{ p: 0.3 }}
                        onClick={() => {
                          setShowOrdersGrid();
                          setStatusGrid({
                            rows: data.peikOrderDetail,
                            title: "ارسال پیک",
                          });
                        }}
                      >
                        <ListAltIcon color="secondary" fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="پیک عادی"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              value={data?.normalPeik ? toMoney(data?.normalPeik) : 0}
              variant="filled"
              InputProps={{
                readOnly: true,
                autoComplete: "off",
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title="جزيیات ارسال">
                      <IconButton
                        sx={{ p: 0.3 }}
                        onClick={() => {
                          setShowOrdersGrid();
                          setStatusGrid({
                            rows: data.normalPeikDetail,
                            title: "ارسال پیک عادی",
                          });
                        }}
                      >
                        <ListAltIcon color="secondary" fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="پیک اکسپرس"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              value={data?.expressPeik ? toMoney(data?.expressPeik) : 0}
              variant="filled"
              InputProps={{
                readOnly: true,
                autoComplete: "off",
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title="جزيیات ارسال">
                      <IconButton
                        sx={{ p: 0.3 }}
                        onClick={() => {
                          setShowOrdersGrid();
                          setStatusGrid({
                            rows: data.expressPeikDetail,
                            title: "ارسال پیک اکسپرس",
                          });
                        }}
                      >
                        <ListAltIcon color="secondary" fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="ارسال پست"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              value={data?.postOrder ? toMoney(data?.postOrder) : 0}
              variant="filled"
              InputProps={{
                readOnly: true,
                autoComplete: "off",
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title="جزيیات ارسال">
                      <IconButton
                        sx={{ p: 0.3 }}
                        onClick={() => {
                          setShowOrdersGrid();
                          setStatusGrid({
                            rows: data.postOrderDetail,
                            title: "ارسال پست",
                          });
                        }}
                      >
                        <ListAltIcon color="secondary" fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="ارسال حضوری"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              value={data?.inpersonOrder ? toMoney(data?.inpersonOrder) : 0}
              variant="filled"
              InputProps={{
                readOnly: true,
                autoComplete: "off",
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title="جزيیات ارسال">
                      <IconButton
                        sx={{ p: 0.3 }}
                        onClick={() => {
                          setShowOrdersGrid();
                          setStatusGrid({
                            rows: data.inpersonOrderDetail,
                            title: "ارسال حضوری",
                          });
                        }}
                      >
                        <ListAltIcon color="secondary" fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label=" ارسال پیک ( پارت 1 )"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              value={
                data?.part1?.peikOrder ? toMoney(data?.part1?.peikOrder) : 0
              }
              variant="filled"
              InputProps={{
                readOnly: true,
                autoComplete: "off",
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title="جزيیات ارسال">
                      <IconButton
                        sx={{ p: 0.3 }}
                        onClick={() => {
                          setShowOrdersGrid();
                          setStatusGrid({
                            rows: data.part1?.peikOrderDetail,
                            title: " ارسال پیک ( پارت 1 )",
                          });
                        }}
                      >
                        <ListAltIcon color="secondary" fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label=" ارسال پیک ( پارت 2 )"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              value={
                data?.part2?.peikOrder ? toMoney(data?.part2?.peikOrder) : 0
              }
              variant="filled"
              InputProps={{
                readOnly: true,
                autoComplete: "off",
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title="جزيیات ارسال">
                      <IconButton
                        sx={{ p: 0.3 }}
                        onClick={() => {
                          setShowOrdersGrid();
                          setStatusGrid({
                            rows: data.part2?.peikOrderDetail,
                            title: " ارسال پیک ( پارت 2 )",
                          });
                        }}
                      >
                        <ListAltIcon color="secondary" fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label=" ارسال پیک ( پارت 3 )"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              value={
                data?.part3?.peikOrder ? toMoney(data?.part3?.peikOrder) : 0
              }
              variant="filled"
              InputProps={{
                readOnly: true,
                autoComplete: "off",
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title="جزيیات ارسال">
                      <IconButton
                        sx={{ p: 0.3 }}
                        onClick={() => {
                          setShowOrdersGrid();
                          setStatusGrid({
                            rows: data.part3?.peikOrderDetail,
                            title: " ارسال پیک ( پارت 3 )",
                          });
                        }}
                      >
                        <ListAltIcon color="secondary" fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="مبلغ دریافت شده اکسپرس"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                data?.expressReciveCost ? toMoney(data?.expressReciveCost) : 0
              }
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="مبلغ پرداخت شده اکسپرس"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={data?.expressPayCost ? toMoney(data?.expressPayCost) : 0}
              variant="filled"
            />
          </Box>

          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            gridColumn="span 12"
          >
            <Button
              onClick={() =>
                navigate("/deliveryreport", {
                  state: location.state,
                  replace: true,
                })
              }
              color="secondary"
              variant="contained"
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        ""
      )}
      <Box sx={{ display: "flex", alignItems: "end", gap: 2, mb: 10 }}>
        {statusGrid ? (
          <Box sx={{ mt: 2, height: "25rem", width: "50%" }}>
            <Box sx={{ mb: 1, display: "flex", alignItems: "center" }}>
              <FiberManualRecordIcon fontSize="small" color="secondary" />
              <Typography variant="subtitle1" sx={{ color: "secondary.main" }}>
                {statusGrid.title}
              </Typography>
            </Box>
            <DataGrid
              rows={statusGrid.rows}
              columns={columns}
              enableRangeSelection={true}
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{
                Pagination: CustomPagination,
              }}
              componentsProps={{
                pagination: {
                  isLtr: true,
                  nofab: true,
                  noPage: true,
                },
              }}
            />
          </Box>
        ) : (
          ""
        )}
        {showOrdersGrid ? (
          <Box sx={{ mt: 2, height: "25rem", width: "50%" }}>
            <Typography
              variant="subtitle1"
              sx={{ mb: 1, color: "secondary.main" }}
            >
              کد سفارشات
            </Typography>
            <DataGrid
              rows={showOrdersGrid.map((item) => ({
                id: item,
              }))}
              columns={[
                {
                  field: "id",
                  headerName: "کد سفارش",
                  width: 150,
                  align: "center",
                  headerAlign: "center",
                },
              ]}
              enableRangeSelection={true}
              disableColumnMenu
              hideFooterSelectedRowCount
              page={pageState.page - 1}
              pageSize={20}
              Pagination
              onPageChange={(newPage) => {
                setPageState((old) => ({ ...pageState, page: newPage + 1 }));
              }}
              components={{
                Pagination: CustomPagination,
              }}
              componentsProps={{
                pagination: {
                  isLtr: true,
                  nofab: true,
                  // noPage: true,
                },
              }}
            />
          </Box>
        ) : (
          ""
        )}
      </Box>
    </Detail>
  );
}
